export const transformedSearchSynonyms = (synonyms = []) => {
	return synonyms.map((synonym) => {
		return {
			keywords: synonym.keywords,
			id: synonym.id,
		};
	});
};
